/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Since_Or_Trend_On_HistoricalInputs */

const en_us2_injury_since_or_trend_on_historical = /** @type {(inputs: Injury_Since_Or_Trend_On_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only a pain you have now carries a start date and a trend.`)
};

const pt_br2_injury_since_or_trend_on_historical = /** @type {(inputs: Injury_Since_Or_Trend_On_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só uma dor que você sente agora tem data de início e evolução.`)
};

const es_419_injury_since_or_trend_on_historical = /** @type {(inputs: Injury_Since_Or_Trend_On_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo un dolor que sientes ahora tiene fecha de inicio y evolución.`)
};

const pt_pt2_injury_since_or_trend_on_historical = /** @type {(inputs: Injury_Since_Or_Trend_On_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só uma dor que sentes agora tem data de início e evolução.`)
};

const fr_fr2_injury_since_or_trend_on_historical = /** @type {(inputs: Injury_Since_Or_Trend_On_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seule une douleur actuelle a une date de début et une évolution.`)
};

const de_de2_injury_since_or_trend_on_historical = /** @type {(inputs: Injury_Since_Or_Trend_On_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur ein Schmerz, den du jetzt hast, hat ein Startdatum und einen Verlauf.`)
};

const it_it2_injury_since_or_trend_on_historical = /** @type {(inputs: Injury_Since_Or_Trend_On_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo un dolore che hai adesso ha una data di inizio e un andamento.`)
};

/**
* | output |
* | --- |
* | "Only a pain you have now carries a start date and a trend." |
*
* @param {Injury_Since_Or_Trend_On_HistoricalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const injury_since_or_trend_on_historical = /** @type {((inputs?: Injury_Since_Or_Trend_On_HistoricalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Since_Or_Trend_On_HistoricalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_injury_since_or_trend_on_historical(inputs)
	if (locale === "es-419") return es_419_injury_since_or_trend_on_historical(inputs)
	if (locale === "pt-PT") return pt_pt2_injury_since_or_trend_on_historical(inputs)
	if (locale === "fr-FR") return fr_fr2_injury_since_or_trend_on_historical(inputs)
	if (locale === "de-DE") return de_de2_injury_since_or_trend_on_historical(inputs)
	if (locale === "it-IT") return it_it2_injury_since_or_trend_on_historical(inputs)
	return en_us2_injury_since_or_trend_on_historical(inputs)
});
export { injury_since_or_trend_on_historical as "injury.since_or_trend_on_historical" }